import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconAddressBook(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <g clipPath="url(#clip0_801_18444)">
        <path
          d="M10.5 0.5H2.5C1.94772 0.5 1.5 0.947715 1.5 1.5V10.5C1.5 11.0523 1.94772 11.5 2.5 11.5H10.5C11.0523 11.5 11.5 11.0523 11.5 10.5V1.5C11.5 0.947715 11.0523 0.5 10.5 0.5Z"
          stroke="currentColor"
        />
        <path d="M0 10.5H2" stroke="currentColor" />
        <path d="M0 7.5H2" stroke="currentColor" />
        <path d="M0 4.5H2" stroke="currentColor" />
        <path d="M0 1.5H2" stroke="currentColor" />
        <circle cx="6.5" cy="4.5" r="2" stroke="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5322 11.5C9.79589 10.0183 8.26686 9 6.5 9C4.73314 9 3.20411 10.0183 2.46776 11.5H1.5V11.2055C2.36961 9.31362 4.2814 8 6.5 8C8.7186 8 10.6304 9.31363 11.5 11.2055V11.5H10.5322Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_801_18444">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
